import React from 'react';
import { color, Box, BoxProps, Flex } from '@kistech/kis-ui';

const PlaceholderBox = (boxProps: BoxProps) => (
  <Box width={80} height={5} style={{ backgroundColor: color.X_LIGHT_GRAY }} {...boxProps} />
);

interface ImageUploadPreviewProps {
  fileUrl: string;
  width: number;
  halfPreview?: boolean;
  imageType?: string;
}
export const ImageUploadPreview: React.FC<ImageUploadPreviewProps> = (props: ImageUploadPreviewProps) => {
  const { fileUrl, width, imageType, halfPreview = false } = props;
  const height = Math.floor(width * 1080) / 1920;

  if (imageType === 'genre' || imageType === 'event' || imageType === 'venue') {
    return <img alt="preview" width={200} height={150} src={fileUrl} style={{ objectFit: 'cover' }} />;
  }
  if (halfPreview) {
    return (
      <Flex
        direction="row"
        margin="3 0"
        width={width}
        height={height}
        style={{ border: `1px solid ${color.LIGHT_GRAY}` }}
      >
        <img alt="preview" width={width / 2} height={height} src={fileUrl} style={{ backgroundSize: 'cover' }} />
        <Flex direction="column" align="center" justify="center" fullHeight flexOverride="1">
          <PlaceholderBox />
          <PlaceholderBox margin="2 0 4" />
          <PlaceholderBox width={40} />
        </Flex>
      </Flex>
    );
  }
  return <img alt="preview" width={width} height={height} src={fileUrl} style={{ objectFit: 'cover' }} />;
};
